/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const order = {
  orderDetails: {
    orderId: 'Ordem #',
    orderNumber: 'Número do pedido',
    replenishmentId: 'Substituição #',
    purchaseOrderId: 'Ordem de compra #',
    purchaseOrderNumber: 'Número do pedido',
    emptyPurchaseOrderId: 'Nenhum',
    none: 'Nenhum {{{value}}',
    placed: 'Obter',
    placedBy: 'Obter By',
    unit: 'Unidade',
    costCenter: 'Centro de custo',
    costCenterAndUnidade: 'Centro de custo / Unidade',
    costCenterAndUnidadeValue: '{{costCenterName}} / {{unitName}}',
    methodOfPayment: 'Forma de pagamento',
    payByAccount: 'Pagamento por conta',
    paidByCreditCard: '(pago com cartão de crédito)',
    status: 'Estado',
    active: 'Ativo',
    shippedOn: 'postado em',
    shippingMethod: 'Método de envio',
    placedOn: 'Data da compra',
    startOn: 'Inicie o',
    nextOrderDate: 'Data do próximo pedido',
    frequency: 'Frequência',
    cancelled: ' Anulado',
    deliveryStatus_IN_TRANSIT: 'Em trânsito',
    deliveryStatus_READY_FOR_PICKUP: 'Pronto para pegar',
    deliveryStatus_READY_FOR_SHIPPING: 'Pronto para envio',
    deliveryStatus_WAITING: 'Esperar',
    deliveryStatus_DELIVERING: 'Entrega',
    deliveryStatus_PICKPACK: 'Preparação para envio',
    deliveryStatus_PICKUP_COMPLETE: 'Recolha completa',
    deliveryStatus_DELIVERY_COMPLETED: 'Entrega completa',
    deliveryStatus_PAYMENT_NOT_CAPTURED: 'Problema de pagamento',
    deliveryStatus_IN_PROCESS: 'Em processo',
    deliveryStatus_READY: 'Em processo',
    deliveryStatus_DELIVERY_REJECTED: 'Entrega recusada',
    deliveryStatus_SHIPPED: 'Enviado',
    deliveryStatus_TAX_NOT_COMMITTED: 'Questão tributária',
    deliveryStatus_CANCELLED: 'Anulado',
    statusDisplay_cancelled: 'Anulado',
    statusDisplay_cancelling: 'Cancelar pendente',
    statusDisplay_completed: 'Concluído',
    statusDisplay_created: 'Criado',
    statusDisplay_error: 'Brinco',
    statusDisplay_checked_valid: 'Brinco',
    statusDisplay_Error: 'Brinco',
    statusDisplay_processing: 'Brinco',
    statusDisplay_open: 'Abrir',
    statusDisplay_pending: {
      approval: 'Aprovação Brinco',
      merchant: {
        approval: 'Aprovação do comerciante Brinco',
      },
    },
    payment: {
      title: 'Informação de Faturamento',
      subtitle: 'Detalhes do Pagamento',
      user: 'Pedido realizado por:',
      clientNumber: 'Número do Cliente:',
      orderNumber: 'Número do Pedido:'
    },
    downloadOrder: 'Baixar Pedido - PDF',
    statusDisplay_approved: 'Aprovado',
    statusDisplay_rejected: 'Indeferido',
    statusDisplay_merchant: {
      approved: 'Merchant Aprovado',
      rejected: 'Comerciante Indeferido',
    },
    statusDisplay_assigned: {
      admin: 'Atribuído ao administrador',
    },
    consignmentTracking: {
      action: 'Pacote de rastreamento',
      dialog: {
        header: 'Informações de rastreamento',
        shipped: 'Enviado',
        estimate: 'Entrega estimada',
        carrier: 'Serviço de entrega',
        trackingId: 'Número de rastreamento',
        noTracking:
          'O pacote não foi enviado do armazém. As informações de rastreamento estarão disponíveis após o envio do pacote.',
        loadingHeader: 'Rastreamento de remessa',
      },
    },
    cancellationAndReturn: {
      returnAction: 'Solicite uma devolução',
      cancelAction: 'Cancelar itens',
      item: 'Artigo',
      itemPrice: 'Preço do item',
      quantity: 'Quantidade máxima',
      returnQty: 'Valor a reembolsar',
      cancelQty: 'Valor a cancelar',
      setAll: 'Definir todas as quantidades para o máximo',
      totalPrice: 'Total',
      submit: 'Enviar solicitação',
      submitDescription:
        'Enviar solicitação. Os itens desta página serão incluídos na solicitação de cancelamento.',
      returnSuccess: 'O seu pedido de devolução ({{{rma}}) foi enviado',
      cancelSuccess:
        'Sua solicitação de cancelamento foi enviada (o pedido original {{{orderCode}} será atualizado)',
    },
    cancelReplenishment: {
      title: 'Cancelar reabastecimento',
      description: 'Cancelar qualquer pedido de reabastecimento futuro?',
      accept: 'Sim',
      reject: 'Não',
      cancelSuccess:
        'A ordem de reabastecimento #{{{replenishmentOrderCode}} foi cancelada com sucesso',
    },
    caption: 'Conteúdo do pedido.',
  },
  orderHistory: {
    downloadAll: {
      pdf: 'Baixar tudo'
    },
    download: 'Baixar',
    select: 'Selecionar tudo',
    orderHistory: 'Histórico de pedidos',
    orderId: 'Ordem #',
    emptyPurchaseOrderId: 'Nenhum',
    date: 'Data',
    status: 'Estado',
    PONumber: 'Número de correspondência',
    total: 'Total',
    noOrders: 'Não temos registros de pedidos para esta conta.',
    noReplenishmentOrders:
      'Não temos registros de pedidos de reabastecimento para esta conta.',
    startShopping: 'Comece a comprar',
    sortBy: 'Classificar por',
    sortOrders: 'Critérios de classificação',
    replenishmentOrderHistory: 'Histórico de pedidos de reabastecimento',
    replenishmentOrderId: 'Substituição #',
    purchaseOrderNumber: 'DEPOIS #',
    costCenter: 'Centro de custo',
    startOn: 'Inicie o',
    frequency: 'Frequência',
    nextOrderDate: 'Data do próximo pedido',
    cancel: 'Cancelar',
    cancelled: 'Anulado',
    replenishmentHistory: 'Histórico de reabastecimento',
    notFound: 'Não se han encontrado pedidos',
    actions: 'Ações',
  },
  AccountOrderHistoryTabContainer: {
    tabs: {
      AccountOrderHistoryComponent: 'TODAS AS ENCOMENDAS ({{param}})',
      OrderReturnRequestListComponent: 'DEVOLUÇÕES ({{param}})',
    },
    tabPanelContainerRegion: 'Grupo com detalhes do histórico de pedidos',
  },
  returnRequestList: {
    returnRequestId: 'Retornar #',
    orderId: 'Ordem #',
    date: 'Data Criado',
    status: 'Estado',
    sortBy: 'Classificar por',
    sortReturns: 'Devoluções de pedidos',
    statusDisplay_APPROVAL_PENDING: 'Aprovação Brinco',
    statusDisplay_CANCELED: 'Anulado',
    statusDisplay_CANCELLING: 'Cancelarling',
    statusDisplay_WAIT: 'Esperar',
    statusDisplay_RECEIVED: 'Recebido',
    statusDisplay_RECEIVING: 'Receber',
    statusDisplay_APPROVING: 'Aprovação',
    statusDisplay_REVERSING_PAYMENT: 'Estornar o pagamento',
    statusDisplay_PAYMENT_REVERSED: 'Pagamento reverso',
    statusDisplay_PAYMENT_REVERSAL_FAILED: 'Falha na reversão de pagamento',
    statusDisplay_REVERSING_TAX: 'Estorno do imposto',
    statusDisplay_TAX_REVERSED: 'Reverter impostos',
    statusDisplay_TAX_REVERSAL_FAILED: 'Falha na reversão de imposto',
    statusDisplay_COMPLETED: 'Concluído',
  },
  returnRequest: {
    returnRequestId: 'Solicitação de devolução #',
    orderCode: 'Para o pedido #',
    status: 'Status de retorno',
    cancel: 'Cancelar solicitação de devolução',
    item: 'Descrição',
    itemPrice: 'Preço do item',
    returnQty: 'Valor devolvido',
    total: 'Total',
    summary: 'Totais de retorno',
    subtotal: 'Subtotal',
    deliveryCode: 'Custos de envio',
    estimatedRefund: 'Reembolso estimado',
    note: 'Os totais são estimativas e podem não incluir impostos ou outras taxas aplicáveis.',
    cancelSuccess: 'O seu pedido de devolução ({{{rma}}) foi cancelado',
    caption: 'Conteúdo do pedido.',
  },
  reorder: {
    button: 'Reordenar',
    dialog: {
      reorderProducts: 'Reordenação de produtos',
      messages: {
        reviewConfiguration:
          'An error occurred with "{{ productCode}}" configuration.',
        lowStock:
          'Valor para {productName}}: {{quantity}} foi reduzido para {{ quantityAdded }}.',
        noStock: '{{ productName } está esgotado no momento.',
        pricingError: 'Pricing problem with "{{ productCode }}".',
        unresolvableIssues: 'Unrecognized problem with "{{ productCode }}".',
        success: 'Os produtos foram adicionados com sucesso ao carrinho',
      },
      areYouSureToReplaceCart: 'O carrinho atual será substituído por novos itens. Quer continuar?',
      cancel: 'Cancelar',
      continue: 'Continuar',
    },
  },
};
